import { Box, CssBaseline } from '@mui/material'
import { ReactNode } from 'react';
import Header from './Header'

type Props = {
  children: ReactNode
}

function Page({ children }: Props): JSX.Element {
  return (
    <>
      <CssBaseline />
      <Header />
      <Box width={1} px={2} mb={10}>
        {children}
      </Box>
    </>
  )
}

export default Page
